// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2l4Hy","col":"styles_col__2L_-r"};